import Swal from "sweetalert2";

export default function (error, errorMessage) {
    console.log(error)
    let message = errorMessage || "Ocorreu um erro ao processar a sua solicitação.";
    if (error && error.data && error.data.error && error.data.error.description) message = error.data.error.description;
    return Swal.fire("Ops...", message, "error");
}